import { render } from "./gameHistoryList.vue?vue&type=template&id=3bc2b458&scoped=true"
import script from "./gameHistoryList.vue?vue&type=script&lang=js"
export * from "./gameHistoryList.vue?vue&type=script&lang=js"

import "./gameHistoryList.vue?vue&type=style&index=0&id=3bc2b458&scoped=true&lang=css"
import "./gameHistoryList.vue?vue&type=style&index=1&id=3bc2b458&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc2b458"]])

export default __exports__